__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@digital-ui/common", "1.18.55", () => (Promise.all([__webpack_require__.e(973), __webpack_require__.e(8063), __webpack_require__.e(8498), __webpack_require__.e(3686), __webpack_require__.e(4961), __webpack_require__.e(8749), __webpack_require__.e(9500)]).then(() => (() => (__webpack_require__(4961))))));
			register("@prism-ui/react", "7.30.2", () => (Promise.all([__webpack_require__.e(3124), __webpack_require__.e(8498), __webpack_require__.e(1771)]).then(() => (() => (__webpack_require__(3124))))));
			register("@tanstack/react-query", "4.29.3", () => (() => (__webpack_require__(5910))), 1);
			register("classnames", "2.3.2", () => (() => (__webpack_require__(2273))), 1);
			register("dompurify", "3.1.6", () => (__webpack_require__.e(3778).then(() => (() => (__webpack_require__(3778))))));
			register("formik", "2.4.4", () => (__webpack_require__.e(5165).then(() => (() => (__webpack_require__(5165))))));
			register("js-cookie", "3.0.1", () => (() => (__webpack_require__(3478))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(8485))), 1);
			register("react-error-boundary", "4.0.3", () => (() => (__webpack_require__(8188))), 1);
			register("react-modal", "3.16.1", () => (Promise.all([__webpack_require__.e(9716), __webpack_require__.e(8498)]).then(() => (() => (__webpack_require__(9716))))));
			register("react-router-dom", "6.11.2", () => (() => (__webpack_require__(4980))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(7552))), 1);
			register("wretch", "2.9.0", () => (() => (__webpack_require__(6342))), 1);
			register("zod", "3.20.6", () => (__webpack_require__.e(6195).then(() => (() => (__webpack_require__(6195))))));
			register("zustand/middleware", "4.3.5", () => (__webpack_require__.e(8267).then(() => (() => (__webpack_require__(8267))))));
			register("zustand", "4.3.5", () => (__webpack_require__.e(5404).then(() => (() => (__webpack_require__(5404))))));
			initExternal(7546);
			initExternal(5057);
			initExternal(9353);
			initExternal(5196);
			initExternal(8270);
			initExternal(1862);
			initExternal(6271);
			initExternal(1464);
			initExternal(3331);
			initExternal(8928);
			initExternal(8189);
			initExternal(8743);
			initExternal(8158);
			initExternal(234);
			initExternal(512);
			initExternal(2309);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};